/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap').default

const Vue = require('vue').default

import VueRouter from 'vue-router'

Vue.use(VueRouter)
import VTooltip from 'v-tooltip'

Vue.use(VTooltip)

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

import http from './http'
import router from './routes'

require('./filters').default

router.beforeEach((to, from, next) => {
    document.title = to.matched.map(m => m.meta['title']).filter(s => s)[0] + ' | Horisont Gruppen AIOS'

    if (to.matched.map(m => m.meta['auth']).filter(s => s)[0]) {
        return http.get('/api/v1/me')
            .then(next)
            .catch(() => {
                router.push('/login')
            })
    }

    next()
})

const app = new Vue({
    el: '#app',

    router
})
